import axios from 'axios'; // 引入axios
import Vue from 'vue';
import store from '../store/index';
import router from '../router/index';
import CryptData from '../utils/cryptData';
import { MessageBox } from 'element-ui';

/** 传输数据加密 */
const dataKey = 'gfdV38Wv9pSDysPZ';

// 环境的切换
// if (process.env.NODE_ENV == "development") {
//   axios.defaults.baseURL = "";
// } else if (process.env.NODE_ENV == "production") {
//   axios.defaults.baseURL = "http://koi.xun-ao.com/koi";
// }

axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
// 请求超时时间
axios.defaults.timeout = 60000;

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // load.open();
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断

    const userId = store.state.userInfo.userId;
    const token = localStorage.getItem('token');
    token && (config.headers.Authorization = token);
    userId && (config.headers.userId = userId);
    if (config.data) {
      config.data = {
        data: CryptData.encryptByAES(JSON.stringify(config.data), dataKey)
      };
    }
    return config;
  },
  error => {
    return Promise.error(error);
  }
);

let error_402 = true;
// 响应拦截器
axios.interceptors.response.use(
  response => {
    // load.close();
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误

    response.data = JSON.parse(CryptData.decryptByAES(response.data, dataKey));
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    console.log(error);
    // Loading().close();
    if (error.response.status) {
      switch (error.response.status) {
        case 402:
          // 清除token

          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          var loginreg = /\/login/gi;
          MessageBox.alert('检测到账号尚未登录，请先登录', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              localStorage.removeItem('token');
              store.dispatch('setUserInfo', {});
              if (!loginreg.test(window.location.href)) {
                router.replace({
                  path: '/login',
                  query: {
                    redirect: router.currentRoute.fullPath
                  }
                });
              }
            }
          });
          break;
        case 403:
          //黑名单
          MessageBox.alert('您的账号已被拉入黑名单', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              localStorage.removeItem('token');
              store.dispatch('setUserInfo', {});
              router.replace({
                path: '/login'
              });
            }
          });
          break;
        // 404请求不存在
        case 404:
          Vue.$alert('提示', '网络请求不存在', {
            confirmButtonText: '确定',
            callback: action => {}
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          Vue.$alert('提示', error.response.data.message, {
            confirmButtonText: '确定',
            callback: action => {}
          });
      }
      return Promise.reject(error.response);
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
